export const GET_SIM_CARDS_REQUEST = "GET_SIM_CARDS_REQUEST";
export const GET_SIM_CARDS_SUCCESS = "GET_SIM_CARDS_SUCCESS";
export const GET_SIM_CARDS_FAILURE = "GET_SIM_CARDS_FAILURE";

export const GET_TYPING_SIM_CARDS_REQUEST = "GET_TYPING_SIM_CARDS_REQUEST";

export const GET_SIM_CARDS_STATUSES_REQUEST = "GET_SIM_CARDS_STATUSES_REQUEST";
export const GET_SIM_CARDS_STATUSES_SUCCESS = "GET_SIM_CARDS_STATUSES_SUCCESS";
export const GET_SIM_CARDS_STATUSES_FAILURE = "GET_SIM_CARDS_STATUSES_FAILURE";

export const GET_SIM_CARDS_SUBSTATUSES_REQUEST = "GET_SIM_CARDS_SUBSTATUSES_REQUEST";
export const GET_SIM_CARDS_SUBSTATUSES_SUCCESS = "GET_SIM_CARDS_SUBSTATUSES_SUCCESS";
export const GET_SIM_CARDS_SUBSTATUSES_FAILURE = "GET_SIM_CARDS_SUBSTATUSES_FAILURE";

export const GET_HISTORY_SIM_CARDS_REQUEST = "GET_HISTORY_SIM_CARDS_REQUEST";
export const GET_HISTORY_SIM_CARDS_SUCCESS = "GET_HISTORY_SIM_CARDS_SUCCESS";
export const GET_HISTORY_SIM_CARDS_FAILURE = "GET_HISTORY_SIM_CARDS_FAILURE";


export const SUBMIT_SIM_CARDS_BATCH_REQUEST = "SUBMIT_SIM_CARDS_BATCH_REQUEST";
export const SUBMIT_SIM_CARDS_BATCH_SUCCESS = "SUBMIT_SIM_CARDS_BATCH_SUCCESS";
export const SUBMIT_SIM_CARDS_BATCH_FAILURE = "SUBMIT_SIM_CARDS_BATCH_FAILURE";

export const SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST = "SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST";
export const SUBMIT_SIMCARDS_VALIDATE_BATCH_SUCCESS = "SUBMIT_SIMCARDS_VALIDATE_BATCH_SUCCESS";
export const SUBMIT_SIMCARDS_VALIDATE_BATCH_FAILURE = "SUBMIT_SIMCARDS_VALIDATE_BATCH_FAILURE";
export const CLEAN_VALIDATED_SIMCARDS = "CLEAN_VALIDATED_SIMCARDS";

export const SUBMIT_SIM_CARDS_REQUEST = "SUBMIT_SIM_CARDS_REQUEST";
export const SUBMIT_SIM_CARDS_SUCCESS = "SUBMIT_SIM_CARDS_SUCCESS";
export const SUBMIT_SIM_CARDS_FAILURE = "SUBMIT_SIM_CARDS_FAILURE";

export const SUBMIT_SIM_CARDS_STATUSES_REQUEST = "SUBMIT_SIM_CARDS_STATUSES_REQUEST";
export const SUBMIT_SIM_CARDS_STATUSES_SUCCESS = "SUBMIT_SIM_CARDS_STATUSES_SUCCESS";
export const SUBMIT_SIM_CARDS_STATUSES_FAILURE = "SUBMIT_SIM_CARDS_STATUSES_FAILURE";

export const PATCH_SIMCARDS_BATCH_REQUEST = "PATCH_SIMCARDS_BATCH_REQUEST";
export const PATCH_SIMCARDS_BATCH_SUCCESS = "PATCH_SIMCARDS_BATCH_SUCCESS";
export const PATCH_SIMCARDS_BATCH_FAILURE = "PATCH_SIMCARDS_BATCH_FAILURE";

export const SET_STATE_SIM_CARDS = "SET_STATE_SIM_CARDS";

export const SET_SIMCARD_SELECTED = "SET_SIMCARD_SELECTED";

export const GET_EXPORT_SIMCARDS_REQUEST = "GET_EXPORT_SIMCARDS_REQUEST";
export const GET_EXPORT_SIMCARDS_SUCCESS = "GET_EXPORT_SIMCARDS_SUCCESS";
export const GET_EXPORT_SIMCARDS_FAILURE = "GET_EXPORT_SIMCARDS_FAILURE";

export const CLOSE_PING_EVENT_EXPORT_SIMCARDS = "CLOSE_PING_EVENT_EXPORT_SIMCARDS";


export const getSimCardsRequest = (filters = {}) => ({
    type: GET_SIM_CARDS_REQUEST,
    payload: {
        filters
    }
});

export const getSimCardsSuccess = (simCards, total, replace = false) => ({
    type: GET_SIM_CARDS_SUCCESS,
    payload: {
        simCards,
        total,
        replace
    }
});

export const getSimCardsFailure = err => ({
    type: GET_SIM_CARDS_FAILURE,
    error: err
});

export const getTypingSimcardsRequest = (filters = {}) => ({
    type: GET_TYPING_SIM_CARDS_REQUEST,
    payload: {
        filters
    }
});

export const getSimcardsStatusesRequest = (filters = {}) => ({
    type: GET_SIM_CARDS_STATUSES_REQUEST,
    payload: {
        filters
    }
});

export const getSimcardsStatusesSuccess = (statuses, total) => ({
    type: GET_SIM_CARDS_STATUSES_SUCCESS,
    payload: {
        statuses
    }
});

export const getSimcardsStatusesFailure = err => ({
    type: GET_SIM_CARDS_STATUSES_FAILURE,
    error: err
});

export const getSimcardsSubstatusesRequest = (filters = {}) => ({
    type: GET_SIM_CARDS_SUBSTATUSES_REQUEST,
    payload: {
        filters
    }
});

export const getSimcardsSubstatusesSuccess = (substatuses, total) => ({
    type: GET_SIM_CARDS_SUBSTATUSES_SUCCESS,
    payload: {
        substatuses
    }
});

export const getSimcardsSubstatusesFailure = err => ({
    type: GET_SIM_CARDS_SUBSTATUSES_FAILURE,
    error: err
});

export const getHistorySimcardsRequest = (payload = {}) => {
    return {
        type: GET_HISTORY_SIM_CARDS_REQUEST,
        payload
    };
};

export const getHistorySimcardsSuccess = (history, total) => ({
    type: GET_HISTORY_SIM_CARDS_SUCCESS,
    payload: {
        history
    }
});

export const getHistorySimcardsFailure = err => ({
    type: GET_HISTORY_SIM_CARDS_FAILURE,
    error: err
});

export const submitSimCardsBatchRequest = simCard => ({
    type: SUBMIT_SIM_CARDS_BATCH_REQUEST,
    payload: {
        simCard
    }
});

export const submitSimCardsBatchSuccess = simCards => ({
    type: SUBMIT_SIM_CARDS_BATCH_SUCCESS,
    payload: {
        simCards
    }
});

export const submitSimCardsBatchFailure = err => ({
    type: SUBMIT_SIM_CARDS_BATCH_FAILURE,
    error: err
});

export const patchSimcardsBatchRequest = (data, options = {}) => ({
    type: PATCH_SIMCARDS_BATCH_REQUEST,
    payload: {
        simcards: data,
        options
    }
});

export const patchSimcardsBatchSuccess = validations => ({
    type: PATCH_SIMCARDS_BATCH_SUCCESS,
    payload: {
        validations
    }
});

export const patchSimcardsBatchFailure = err => ({
    type: PATCH_SIMCARDS_BATCH_FAILURE,
    error: err
});

export const submitSimcardsValidateBatchRequest = simcard => ({
    type: SUBMIT_SIMCARDS_VALIDATE_BATCH_REQUEST,
    payload: {
        simcard
    }
});

export const submitSimcardsValidateBatchSuccess = validations => ({
    type: SUBMIT_SIMCARDS_VALIDATE_BATCH_SUCCESS,
    payload: {
        validations
    }
});

export const submitSimcardsValidateBatchFailure = err => ({
    type: SUBMIT_SIMCARDS_VALIDATE_BATCH_FAILURE,
    error: err
});

export const cleanValidatedSimcards = () => ({ type: CLEAN_VALIDATED_SIMCARDS });

export const submitSimcardsRequest = simCard => ({
    type: SUBMIT_SIM_CARDS_REQUEST,
    payload: {
        simCard
    }
});

export const submitSimcardsSuccess = simCard => ({
    type: SUBMIT_SIM_CARDS_SUCCESS,
    payload: {
        simCard
    }
});

export const submitSimcardsFailure = err => ({
    type: SUBMIT_SIM_CARDS_FAILURE,
    error: err
});

export const submitSimcardsStatusesRequest = status => ({
    type: SUBMIT_SIM_CARDS_STATUSES_REQUEST,
    payload: {
        status
    }
});

export const submitSimcardsStatusesSuccess = status => ({
    type: SUBMIT_SIM_CARDS_STATUSES_SUCCESS,
    payload: {
        status
    }
});

export const submitSimcardsStatusesFailure = err => ({
    type: SUBMIT_SIM_CARDS_STATUSES_FAILURE,
    error: err
});

export const setStateSimcards = (state) => ({
    type: SET_STATE_SIM_CARDS,
    payload: state
});

export const setSimcardSelected = (simcard = {}) => ({
    type: SET_SIMCARD_SELECTED,
    payload: {
        simcard
    }
});

export const getExportSimcardsRequest = (filters) => ({
    type: GET_EXPORT_SIMCARDS_REQUEST,
    payload: {
        filters
    }
});

export const getExportSimcardsSuccess = (fileName) => ({
    type: GET_EXPORT_SIMCARDS_SUCCESS,
    payload: {
        fileName
    }
});

export const getExportSimcardsFailure = () => ({
    type: GET_EXPORT_SIMCARDS_FAILURE,
    
});


export const closePingEventExportSimcards = () => ({
    type: CLOSE_PING_EVENT_EXPORT_SIMCARDS,
});